// extracted by mini-css-extract-plugin
export default {"off":"Switch__off___3zclR"};